import script from "./AdminIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIndex.vue?vue&type=script&setup=true&lang=js"

import "./AdminIndex.vue?vue&type=style&index=0&id=e0ae5438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ae5438"]])

export default __exports__